import Button from 'components/control/button';
import styles from './style.module.scss';
import NotificationIcon from 'components/icon/notification-icon';
import HeartIcon from 'components/icon/heart-icon';
import Link from 'components/link';
import { trackEvent } from 'utils/google-tag-manager';
import { useContext, useEffect, useState } from 'react';
import { SavedListingContext } from 'contexts/saved-listing';
import { ModalContext } from 'contexts/modal';
import { listingPageModalIds } from 'constants/test-constants';
import { GTM_CLICK_FAV_ON_LISTING_MODAL, GTM_CLICK_FAV_ON_ADDRESS_PAGE, GTM_CLICK_VIEW_ON_LISTING_MODAL, GTM_CLICK_VIEW_ON_ADDRESS_PAGE } from 'constants/events';
import type { ISavedListingContext } from 'contexts/saved-listing';
import type { IModalContext } from 'contexts/modal';

interface Props {
  listingId: number;
  addressSlug: string;
  isAuthenticated?: boolean;
  isListingModal?: boolean;
}

export default function FavouritePrompt({ listingId, addressSlug, isAuthenticated, isListingModal }: Props) {
  const { openModal, closeAllModals } = useContext(ModalContext) as IModalContext;
  const [isFavourited, setIsFavourited] = useState(false);
  const { savedListings, addSavedListing, isSavedListing } = useContext(SavedListingContext) as ISavedListingContext;

  const gtmFavAlertClk = isListingModal ? GTM_CLICK_FAV_ON_LISTING_MODAL : GTM_CLICK_FAV_ON_ADDRESS_PAGE;
  const gtmFavViewClk = isListingModal ? GTM_CLICK_VIEW_ON_LISTING_MODAL : GTM_CLICK_VIEW_ON_ADDRESS_PAGE;

  const handleClick = () => {
    trackEvent(gtmFavViewClk);
    closeAllModals();
  };

  const addToFavourites = () => {
    trackEvent(gtmFavAlertClk);
    if (isAuthenticated) {
      addSavedListing({ listingId, addressSlug, isModal: isListingModal });
    } else {
      openModal('login-registration');
    }
  };

  useEffect(() => {
    setIsFavourited(isSavedListing(addressSlug));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedListings, addressSlug]);

  return (
    <div className={styles.component} data-testid={listingPageModalIds.favouritePrompt}>
      {isFavourited && isAuthenticated ?
        <>
          <HeartIcon className={styles.icon} />
          <div className={styles['favourited-text']}>
            <p data-testid={listingPageModalIds.favouritePromptText}>You will be notified for this property.
              <br />
              <Link href="/account/saved/favourites" onClick={handleClick} testId={listingPageModalIds.favouritePromptSavedListingsLink} >
                &nbsp;See all My Saved listings.
              </Link>
            </p>
          </div>
        </>
        :
        <>
          <NotificationIcon className={styles.icon} />
          <p data-testid={listingPageModalIds.favouritePromptText}>Get notified of price or status changes by saving this listing</p>
          <Button label="Get Notified" type="submit" theme="tertiary" onClick={addToFavourites} testId={listingPageModalIds.favouritePromptAddButton} />
        </>
      }
    </div>
  );
}
